import React from "react";
import { Outlet } from "react-router-dom";

/**
 * A component that serves as a layout wrapper for all drinking water buildings routes.
 * It uses React Router's Outlet component to render nested routes.
 * 
 * This page displays all drinking water buildings.
 * 
 * @component
 * @returns {JSX.Element} The rendered all drinking water buildings page layout
 * 
 * @example
 * ```tsx
 * <AllDrinkingWaterBuildingsPage />
 * ```
 */
const AllDrinkingWaterBuildingsPage = () => {
  return <Outlet />;
};

export default AllDrinkingWaterBuildingsPage;

